"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getName = void 0;
const ethers_1 = require("ethers");
const NameABI_json_1 = __importDefault(require("../abi/NameABI.json"));
/**
 * Gets `name` from contract (assuming it complies w the ERC721/ERC20 standard)
 */
const getName = async (communityAddress, provider) => {
    if (!ethers_1.ethers.utils.isAddress(communityAddress))
        throw new Error('Community address is not valid');
    const contract = new ethers_1.ethers.Contract(communityAddress, NameABI_json_1.default, provider);
    const name = await contract.name();
    if (!name)
        throw Error(`Error fetching name for contract ${communityAddress}`);
    return name;
};
exports.getName = getName;
